import React, { useState } from 'react';
import { StyledAccordionContent } from './StyledAccordionContent';

const AccordionContent = ({isDouble, innerContent}) => {
  
  


  return (
    <React.Fragment>
      {
       
          <StyledAccordionContent isDouble={isDouble}>
            <div className="accordion--inner-content-wrap">
              {
                <div className="accordion--inner-content">
                  {
                    innerContent.innerTitle &&
                    <p className="preset-9 inner-title">{innerContent.innerTitle}</p>
                  }
                  <p className="preset-10 inner-text" dangerouslySetInnerHTML={{ __html: innerContent.innertText }}></p>
                </div>
              }
            </div>
          </StyledAccordionContent>
          
      }
    </React.Fragment>
  );
};



export default AccordionContent;
